import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from '../repeat/Header';
import Footer from '../repeat/Footer';
import Leftnavigation from './Leftnavigation';
import './style/acadamics.css';
const App = () => {
  const [pdfList, setPdfList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [curriculum, setCurriculum] = useState(''); // To capture the curriculum input

  useEffect(() => {
    fetchPdfList();
  }, []);

  const fetchPdfList = async () => {
    try {
      const response = await axios.get('https://gptkpm.in/backend/admin/acadamics.php');
      setPdfList(response.data);
    } catch (error) {
      console.error('Error fetching PDF list:', error);
    }
  };

  const handleFileChange = (e) => {
    setSelectedFiles(e.target.files);
  };

  const handleFileUpload = async () => {
    if (!selectedFiles || selectedFiles.length === 0 || !curriculum) {
      alert("Please select files and provide curriculum.");
      return;
    }

    const formData = new FormData();
    formData.append('curriculum', curriculum); // Send the curriculum data
    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append('files[]', selectedFiles[i]);
    }

    try {
      await axios.post('https://gptkpm.in/backend/admin/acadamics.php', formData);
      fetchPdfList();
      setSelectedFiles(null);
      setCurriculum('');
    } catch (error) {
      console.error('Error uploading files:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete('https://gptkpm.in/backend/admin/acadamics.php', { data: { id } });
      fetchPdfList();
    } catch (error) {
      console.error('Error deleting file:', error);
    }
  };

  return (
    <div>
      <div>
        <Header />
        <Leftnavigation />
      </div>
      <div className='main-1'>
      <div className='inner-right'>
          <div className='form-acadamic'>
          <h3>Upload Curriculam <br /> Or <br /> Acadamics pdf</h3>
          <input type="text" placeholder="Enter Curriculum" value={curriculum} onChange={(e) => setCurriculum(e.target.value)} />
          <input type="file" multiple onChange={handleFileChange} />
          <button onClick={handleFileUpload} style={{ marginTop: '10px' }}>
            Upload
          </button>
          </div>
        </div>
        <div className='inner-left'>
          <h2>Acadamics List</h2>
          <ul>
            {pdfList.map((pdf) => (
              <li key={pdf.id}>
                <a href={`https://gptkpm.in/backend/admin/uploads/${(pdf.file_name)}`} target="_blank" rel="noopener noreferrer">          
                  <p style={{marginRight:"30px"}}>{pdf.curriculum}</p>
                  <p>{pdf.file_name}</p>
                </a>
                <button onClick={() => handleDelete(pdf.id)} style={{ marginLeft: '10px' }}>
                  Delete
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Right side: Upload Section */}
        
      </div>
      <div>
      <Footer />
      </div>
    </div>
  );
};

export default App;
